import { useMutation } from "@apollo/client";
import mutations from "Shared/mutations";
import { downloadS3File } from "Modules/S3Downloads";
import { handleValidationErrors } from "Modules/HandleValidationErrors";
import { CreateDirectDepositUpdateFileMutation, GenerateBatchOnboardUrlMutationVariables, GenerateDduReportMutation } from "generated/graphql";

export const useDirectDepositDownloadHandler = (
  canCreateDirectDepositUpdateFiles?: boolean
) => {
  const [createDDUFileMutation] = useMutation<CreateDirectDepositUpdateFileMutation>(
    mutations.CREATE_DDU_FILE
  );
  const [downloadDirectDepositMutation] = useMutation<
    GenerateDduReportMutation, GenerateBatchOnboardUrlMutationVariables
  >(mutations.GENERATE_DDU_REPORT);

  const onButtonClickHandler = async () => {
    let url: string | undefined | null = "";

    try {
      if (canCreateDirectDepositUpdateFiles) {
        const result = await createDDUFileMutation();
        url = result?.data?.createDirectDepositUpdateFile?.directDepositUpdateFile?.attachment?.url;
      } else {
        const result = await downloadDirectDepositMutation();
        url = result?.data?.generateDduReportUrl?.reportUrl;
      }
    } catch (err) {
      handleValidationErrors(err);
    }

    !!url && downloadS3File(url);
  };

  return { onButtonClickHandler };
};
